/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Check the cookies

function getCookie(name) {
    var dc = document.cookie;
    var prefix = name + "=";
    var begin = dc.indexOf("; " + prefix);
    if (begin == -1) {
        begin = dc.indexOf(prefix);
        if (begin != 0) return null;
    }
    else
    {
        begin += 2;
        var end = document.cookie.indexOf(";", begin);
        if (end == -1) {
        end = dc.length;
        }
    }
    // because unescape has been deprecated, replaced with decodeURI
    //return unescape(dc.substring(begin + prefix.length, end));
    return decodeURI(dc.substring(begin + prefix.length, end));
} 



function setCookie(cname, cvalue, exdays) {
  const d = new Date();
  d.setTime(d.getTime() + (exdays*24*60*60*1000));
  let expires = "expires="+ d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function cookieConsentCheck () {
  let cookie = "acceptCookie"
  let is_Cookie = getCookie("acceptCookie");
  if(is_Cookie == null) {
    
     $(".cookie-consent").show();
  } else {
    $(".cookie-consent").hide();
  }
  $(".cookie-consent-button").click(function(e){
    e.preventDefault();
    
    setCookie(cookie, "1",395);
     $(".cookie-consent").hide();
  })
}



$(document).ready(function(){
  cookieConsentCheck();
});
